"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionErrorLog = actionErrorLog;
exports.actionErrorMessage = actionErrorMessage;
const logger_1 = require("./logger");
const isProduction = process.env.NODE_ENV === 'production';
/** Generic message shown to the client when the real one is not safe to leak. */
const GENERIC_MESSAGE = 'Something went wrong. Please try again.';
/**
 * Messages that are DELIBERATELY user-facing (auth, quota, validation,
 * not-found). Anything else — DB errors, stack traces, internal detail — is
 * replaced with GENERIC_MESSAGE in production so internals don't leak to the
 * browser. Case-insensitive substring match. In dev the real message passes
 * through for debugging.
 */
const SAFE_PATTERNS = [
    'not authenticated', 'unauthorized', 'forbidden', 'not found', 'not_found',
    'insufficient tokens', 'insufficient balance', 'is required', 'invalid',
    'already exists', 'too many', 'rate limit', 'quota', 'not allowed',
    'unsupported', 'expired', 'cannot be empty', 'must be',
];
function isSafeMessage(message) {
    const m = message.toLowerCase();
    return SAFE_PATTERNS.some((p) => m.includes(p));
}
/** Client-safe message: the real one if it's an intentional user-facing
 *  string, otherwise a generic one in production (full detail in dev). */
function clientMessage(message) {
    if (!isProduction)
        return message;
    return isSafeMessage(message) ? message : GENERIC_MESSAGE;
}
/** Log-only variant for catch blocks that shape their own result/message. */
function actionErrorLog(action, e) {
    logger_1.logger.error('action_error', {
        action,
        error: e instanceof Error ? `${e.message}\n${e.stack ?? ''}` : String(e),
    });
}
/**
 * Log a CAUGHT server-action error (full stack) and return a CLIENT-SAFE
 * message. Server actions swallow errors by design (they return
 * {success:false} to the client); this logs the detail and returns a
 * sanitized message so internals never reach the browser.
 */
function actionErrorMessage(action, e) {
    const raw = e instanceof Error ? e.message : 'Unknown error';
    logger_1.logger.error('action_error', {
        action,
        error: e instanceof Error ? `${e.message}\n${e.stack ?? ''}` : String(e),
    });
    return clientMessage(raw);
}
